import React, { forwardRef } from "react";
import IconBase, { IconProps } from "./icon-base";

export const XIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <IconBase
      ref={ref}
      renderPath={(color: string) => {
        return (
          <>
            <path d="M1 1.00049L8.80935 8.80837" stroke={color} strokeWidth="1.3" strokeLinecap="square" />
            <path d="M8.81055 1L1.0012 8.80788" stroke={color} strokeWidth="1.3" strokeLinecap="square" />
          </>
        );
      }}
      {...props}
    >
      {props.children}
    </IconBase>
  );
});

XIcon.displayName = "XIcon";
